<template>
  <div id='app'>
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import './sass/base.scss';
@import './assets/icon/iconfont.css';
* {
  margin: 0;
  padding: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue